import { Pipe, PipeTransform } from "@angular/core";
import { MediaCategoryTypeNameEnum, MediaViewModel } from "src/domain/client";
import { environment } from "src/environments/environment";
import { SettingService } from "src/services/setting.service";

@Pipe({
  name: "productImageURL",
  pure: true,
})
export class ProductImageURLPipe implements PipeTransform {
  constructor(private settingService: SettingService) {}

  transform(media: MediaViewModel[] | null | undefined, size: string): string {
    const imageMedias = media?.filter(
      (_) =>
        _.mediaCategoryTypeName === MediaCategoryTypeNameEnum.ImageNameSmall ||
        _.mediaCategoryTypeName === MediaCategoryTypeNameEnum.ImageNameMedium ||
        _.mediaCategoryTypeName === MediaCategoryTypeNameEnum.ImageNameLarge,
    );

    if (imageMedias == null || !imageMedias.length) {
      return environment.productImageFallbackURL;
    }

    const imageMedia = imageMedias[0];

    const baseURL = this.settingService.getSetting(size);
    if (baseURL) {
      return `${baseURL}${imageMedia.url}`;
    }

    return "";
  }
}
